export const CARD_CONTENT = {
  amount: {
    visible: true,
    valueClassName: 'bold',
  },
  term: {
    visible: true,
  },
  approvalProbability: {
    visible: true,
  },
  badge: {
    visible: true,
  },
  rate: {
    visible: false,
  },
};
